<template>
  <div class="news">
    <Header :class="{ hidden: isHidden }" />
    <div class="enterprise-core my600 fs45 fc000000">
      <div>
        <a href="#spirit" class="enterprise-spirit">
          公司介绍
          <div class="read my400 fs16 fcB9B9B9">
            点击阅读
            <img src="@/assets/img/index/plus.png" class="plus-img" alt="" />
          </div>
        </a>
      </div>
      <div>
        <a href="#mission" class="corporate-mission">
          荣誉资质
          <div class="read my400 fs16 fcB9B9B9">
            点击阅读
            <img src="@/assets/img/index/plus.png" class="plus-img" alt="" />
          </div>
        </a>
      </div>
      <div>
        <a href="#values" class="corporate-values">
          新闻动态
          <div class="read my400 fs16 fcB9B9B9">
            点击阅读
            <img src="@/assets/img/index/plus.png" class="plus-img" alt="" />
          </div>
        </a>
      </div>
      <div>
        <a href="#vision" class="corporate-vision">
          社会责任
          <div class="read my400 fs16 fcB9B9B9">
            点击阅读
            <img src="@/assets/img/index/plus.png" class="plus-img" alt="" />
          </div>
        </a>
      </div>
      <div class="new-title AlimaBold fs230 fcF5F5F5">Company Profile</div>
    </div>
    <div class="company-profile" id="spirit">
      <div class="profile-title my600 fs60 fc000000">
        公司介绍
        <div class="title-line"></div>
      </div>
      <div class="profile-img">
        <img src="@/assets/img/index/corporate-spirit.png" class="spirit-img" alt="" />
        <div class="profile-blue" @wheel="onScroll">
          <div
            class="circle blue"
            :style="{ transform: `translateY(${offsetY}px)` }"></div>
        </div>
      </div>
      <div class="company-title my600 fs38 fc000000">
        我们始终以文化内容为核心
      </div>
      <div class="profile-content my400 fs26 fc000065">
        <div>
          我们致力于弘扬传统文化、推动社会进步、丰富人民精神文化生活，以及促进文化交流与发展。
        </div>
        <div class="content-team">
          团队成员均来自国内外知名高校，年轻而朝气蓬勃。我们期待为人才提供具有挑战、和能充分施展才华的舞台。共同开创富有想象力、能够突破行业边界、对社会产生深远价值的事业。同时确保优秀的人才收获应得的认可与丰厚回报。
        </div>
      </div>
    </div>
    <div class="honor">
      <div class="honor-title my600 fs60 fc000000" id="mission">
        荣誉资质
        <div class="title-line"></div>
      </div>
      <div class="honor-images">
        <div class="honor-blue" @wheel="onScroll">
          <div
            class="circle blue"
            :style="{ transform: `translateY(${offsetY}px)` }"></div>
        </div>
        <div class="scroll-x-wrapper" ref="scrollWrapper">
          <div class="scroll-x-content" ref="scrollContent">
            <div
              class="scroll-x-item"
              v-for="(item, index) in listData"
              :key="'1-' + index">
              <img :src="item" class="scroll-x-item-img" />
            </div>
            <div
              class="scroll-x-item"
              v-for="(item, index) in listData"
              :key="'2-' + index">
              <img :src="item" class="scroll-x-item-img" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="new-dynamics" id="values">
      <div class="dynamics-blue" @wheel="onScroll">
        <div
          class="circle blue"
          :style="{ transform: `translateY(${offsetY}px)` }"></div>
      </div>
      <div class="news-title my600 fs60 fc000000">
        新闻动态
        <div class="title-line"></div>
      </div>
      <div class="news-content">
        <div class="new-items-first">
          <div class="item-left">
            <div class="item-title my600 fs25 fc000000">
              抖音电商推出“商家复产护航计划”， 九项举措助力商家复工复产
            </div>
            <div class="item-desc my400 fs20 fc000087">
              系列视频在故宫博物院官方抖音账号@带你看故宫
              发布，均由故宫博物院相关领域专业研究人员讲解，现已上线五个合集。
            </div>
            <div class="item-date my400 fs20 fc000065">2025年6月24日</div>
          </div>
          <div class="item-right">
            <img src="@/assets/img/index/corporate-spirit.png" class="news-img" alt="" />
          </div>
        </div>
        <div class="new-items-second">
          <div class="item-right">
            <img src="@/assets/img/index/corporate-spirit.png" class="news-img" alt="" />
          </div>
          <div class="item-left">
            <div class="item-title my600 fs25 fc000000">
              助力黔货出山，“山货上头条”走进贵 州推介地标农品
            </div>
            <div class="item-desc my400 fs20 fc000087">
              黔货借助兴趣电商，跳进了千里之外的消费者购物车里。
            </div>
            <div class="item-date my400 fs20 fc000065">2025年6月24日</div>
          </div>
        </div>
        <div class="new-items-first">
          <div class="item-left">
            <div class="item-title my600 fs25 fc000000">
              抖音电商推出“每日匠心”活动，助力 非遗好物销售
            </div>
            <div class="item-desc my400 fs20 fc000087">
              活动还携手多个领域的手艺人，陆续将橄榄核雕、苏绣、汝瓷、王星记扇等非遗好物带进官方直播间，为观众介绍传统技艺，助力非遗文化走进更多人的日常生活。
            </div>
            <div class="item-date my400 fs20 fc000065">2025年6月24日</div>
          </div>
          <div class="item-right">
            <img src="@/assets/img/index/corporate-spirit.png" class="news-img" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="social-responsibility" id="vision">
      <div class="social-blue" @wheel="onScroll">
        <div
          class="circle blue"
          :style="{ transform: `translateY(${offsetY}px)` }"></div>
      </div>
      <div class="responsibility-title my600 fs60 fc000000">
        社会责任
        <div class="title-line"></div>
      </div>
      <div class="social-content">
        <div class="social-items" v-for="(item, index) in 3" :key="index">
          <div class="social-img">
            <img
              src="@/assets/img/index/corporate-spirit.png"
              class="social-image"
              alt="" />
          </div>
          <div class="social-title my600 fs25 fc000000">字节跳动公益平台</div>
          <div class="social-desc my400 fs20 fc000087">
            字节跳动公益平台是由民政部指定互联网公开募捐信息平台，于2021年11月正式上线。平台致力于将传统公益活动的各个参与方集结在一起，为公益机构提供公益信息发布渠道，为用户提供公益参与渠道。结合抖音、今日头条、西瓜视频等字节产品特色，通过公益信息的传递，高效率连接公益信息与社会资源，让人人能够便捷参与公益的平台。
            通过字节跳动公益平台，公益机构可以在抖音、今日头条、西瓜视频上筹款，来开展公益项目、解决社会问题。
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script setup>
  import Header from "@/components/Header.vue";
  import Footer from "@/components/Footer.vue";
  import { ref, onMounted, onBeforeUnmount } from "vue";

  // 控制圆圈浮动的偏移值
  const offsetY = ref(0);

  const MAX_OFFSET = 80; // 最大浮动像素
  const STEP = 30; // 每次滚动浮动步长

  const onScroll = (event) => {
    if (event.deltaY > 0) {
      // 向下滚动
      offsetY.value = Math.min(offsetY.value + STEP, MAX_OFFSET);
    } else {
      // 向上滚动
      offsetY.value = Math.max(offsetY.value - STEP, -MAX_OFFSET);
    }
  };

  const listData = ref([
    require("@/assets/img/index/corporate-spirit.png"),
    require("@/assets/img/index/corporate-spirit.png"),
    require("@/assets/img/index/corporate-spirit.png"),
    require("@/assets/img/index/corporate-spirit.png"),
    require("@/assets/img/index/corporate-spirit.png"),
    require("@/assets/img/index/corporate-spirit.png"),
    require("@/assets/img/index/corporate-spirit.png"),
    require("@/assets/img/index/corporate-spirit.png"),
  ]);

  const isHidden = ref(false);
  let lastScrollTop = 0;

  const scrollWrapper = ref(null);
  const scrollContent = ref(null);

  let animationFrameId = null;
  let position = 0;
  const speed = 1; // 每帧滚动1px，调节滚动速度

  const step = () => {
    if (scrollWrapper.value && scrollContent.value) {
      const wrapper = scrollWrapper.value;
      const content = scrollContent.value;
      position += speed;
      if (position >= content.scrollWidth / 2) {
        position = 0;
      }
      wrapper.scrollLeft = position;
    }
    animationFrameId = requestAnimationFrame(step);
  };

  const handleScroll = () => {
    const currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > lastScrollTop && currentScroll > 60) {
      isHidden.value = true; // 下滑：隐藏
    } else {
      isHidden.value = false; // 上滑：显示
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  };

  onMounted(() => {
    animationFrameId = requestAnimationFrame(step);
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("wheel", onScroll);
  });

  onBeforeUnmount(() => {
    if (animationFrameId) cancelAnimationFrame(animationFrameId);
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("wheel", onScroll);
  });
</script>

<style scoped lang="less">
  .news {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .enterprise-core {
      display: flex;
      justify-content: space-around;
      align-items: center;
      position: relative;
      margin-top: 120px;
      width: 100%;
      height: 230px;

      .new-title {
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .enterprise-spirit,
      .corporate-mission,
      .corporate-values,
      .corporate-vision {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;

        .read {
          display: flex;
          align-items: center;
          margin-top: 20px;

          .plus-img {
            margin-left: 10px;
            width: 13px;
            height: 13px;
          }
        }
      }
    }

    .company-profile {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 66px;
      width: 1000px;

      .profile-title {
        width: 240px;

        .title-line {
          margin-top: -25px;
          width: 240px;
          height: 24px;
          background: #d3fea3;
        }
      }

      .profile-img {
        position: relative;
        margin-top: 40px;
        width: 100%;
        height: 450px;

        .spirit-img {
          width: 100%;
          height: 100%;
        }

        .profile-blue {
          position: absolute;
          left: -650px;
          top: 0px;
          z-index: -1;
          width: 500px;
          height: 500px;

          .circle {
            border-radius: 50%;
            opacity: 0.6;
            pointer-events: none;
            transition: transform 2.3s ease;
          }

          .blue {
            width: 100%;
            height: 100%;
            background: radial-gradient(circle, rgba(0, 123, 255, 0.2));
          }
        }
      }

      .company-title {
        margin-top: 40px;
        width: 100%;
      }

      .profile-content {
        margin-top: 40px;

        .content-team {
          margin-top: 30px;
          text-align: justify;
        }
      }
    }

    .honor-title {
      margin: 100px auto 0;
      width: 240px;

      .title-line {
        margin-top: -25px;
        width: 240px;
        height: 24px;
        background: #d3fea3;
      }
    }

    .honor-images {
      position: relative;
      margin-top: 40px;
      width: 1400px;

      .honor-blue {
        position: absolute;
        right: -400px;
        bottom: 00px;
        z-index: -1;
        width: 500px;
        height: 500px;

        .circle {
          border-radius: 50%;
          opacity: 0.6;
          pointer-events: none;
          transition: transform 2.3s ease;
        }

        .blue {
          width: 100%;
          height: 100%;
          background: radial-gradient(circle, rgba(255, 254, 176, 0.4));
        }
      }
    }

    .scroll-x-wrapper {
      position: relative;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
    }

    .scroll-x-content {
      display: flex; /* 改成 flex，宽度自动撑开 */
      flex-direction: row;
    }

    .scroll-x-item {
      flex-shrink: 0;
      margin-right: 20px;
      width: 350px;
      height: 247px;
      border-radius: 6px;
    }

    .scroll-x-item-img {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }

    .new-dynamics {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      margin: 100px auto 0;

      .dynamics-blue {
        position: absolute;
        left: -600px;
        top: 0px;
        z-index: -1;
        width: 500px;
        height: 500px;

        .circle {
          border-radius: 50%;
          opacity: 0.6;
          pointer-events: none;
          transition: transform 2.3s ease;
        }

        .blue {
          width: 100%;
          height: 100%;
          background: radial-gradient(circle, rgba(255, 201, 255, 0.2));
        }
      }

      .title-line {
        margin-top: -25px;
        width: 240px;
        height: 24px;
        background: #d3fea3;
      }

      .news-content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-top: 50px;
        width: 1100px;

        .new-items-first {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 100%;
          height: 320px;
          cursor: pointer;

          .item-left {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            padding-left: 40px;
            box-sizing: border-box;
            width: 550px;
            height: 320px;
            background: #f9f9fb;
            border-radius: 10px 0px 0px 10px;

            .item-title {
              margin-top: 30px;
              width: 470px;
              text-align: justify;
            }

            .item-desc {
              margin-top: 20px;
              width: 470px;
              height: 130px;
              text-align: justify;
            }

            .item-date {
              margin: 0px 0 0 0px;
            }
          }

          .item-right {
            width: 550px;
            height: 320px;

            .news-img {
              width: 550px;
              height: 320px;
            }
          }
        }

        .new-items-second {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 40px;
          margin-bottom: 40px;
          width: 100%;
          height: 320px;
          cursor: pointer;

          .item-left {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            padding-left: 40px;
            box-sizing: border-box;
            width: 550px;
            height: 320px;
            background: #f9f9fb;
            border-radius: 10px 0px 0px 10px;

            .item-title {
              margin-top: 30px;
              width: 470px;
              text-align: justify;
            }

            .item-desc {
              margin-top: 20px;
              width: 456px;
              height: 130px;
              text-align: justify;
            }

            .item-date {
              margin: 0px 0 0 0px;
            }
          }

          .item-right {
            width: 550px;
            height: 320px;
            border-radius: 0px 10px 10px 0px;

            .news-img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .social-responsibility {
      position: relative;
      margin: 0 auto;
      margin: 100px 0 100px 0;
      width: 1400px;

      .social-blue {
        position: absolute;
        right: -400px;
        top: -50px;
        z-index: -1;
        width: 500px;
        height: 500px;

        .circle {
          border-radius: 50%;
          opacity: 0.6;
          pointer-events: none;
          transition: transform 2.3s ease;
        }

        .blue {
          width: 100%;
          height: 100%;
          background: radial-gradient(circle, rgba(211, 254, 163,0.4));
        }
      }

      .responsibility-title {
        margin: 0 auto;
        width: 240px;
      }

      .title-line {
        margin-top: -25px;
        width: 240px;
        height: 24px;
        background: #d3fea3;
      }

      .social-content {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;

        .social-items {
          margin-top: 50px;
          width: 420px;

          .social-img {
            width: 100%;
            height: 260px;

            .social-image {
              width: 100%;
              height: 100%;
            }
          }

          .social-title {
            margin-top: 30px;
          }

          .social-desc {
            margin-top: 30px;
            text-align: justify;
          }
        }
      }
    }
  }
</style>
